
      if (sessionStorage.getItem('test-features'))
        document.body.setAttribute('test-features', 'enabled');
    